import { render, staticRenderFns } from "./AiAppSettingDefinitionAssign.vue?vue&type=template&id=108351ea&scoped=true"
import script from "./AiAppSettingDefinitionAssign.vue?vue&type=script&lang=js"
export * from "./AiAppSettingDefinitionAssign.vue?vue&type=script&lang=js"
import style0 from "./AiAppSettingDefinitionAssign.vue?vue&type=style&index=0&id=108351ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108351ea",
  null
  
)

export default component.exports